module.exports = __webpack_public_path__ + "static/media/gal0001.bbfef4fb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/ressources/gal00/gal0001.jpg
// module id = 71
// module chunks = 0